var G = Object.defineProperty, $ = Object.defineProperties;
var Y = Object.getOwnPropertyDescriptors;
var j = Object.getOwnPropertySymbols;
var q = Object.prototype.hasOwnProperty, J = Object.prototype.propertyIsEnumerable;
var x = (i, o, l) => o in i ? G(i, o, { enumerable: !0, configurable: !0, writable: !0, value: l }) : i[o] = l, B = (i, o) => {
  for (var l in o || (o = {}))
    q.call(o, l) && x(i, l, o[l]);
  if (j)
    for (var l of j(o))
      J.call(o, l) && x(i, l, o[l]);
  return i;
}, D = (i, o) => $(i, Y(o));
var A = (i, o, l) => new Promise((p, f) => {
  var v = (u) => {
    try {
      g(l.next(u));
    } catch (d) {
      f(d);
    }
  }, c = (u) => {
    try {
      g(l.throw(u));
    } catch (d) {
      f(d);
    }
  }, g = (u) => u.done ? p(u.value) : Promise.resolve(u.value).then(v, c);
  g((l = l.apply(i, o)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postGetOrgPageList as Q } from "../../request/designordercenter/productionOrder/specialApply/getOrgPageList/post.js";
import { postGetDjjApplyPageList as W } from "../../request/bpmSpecialFlow/getDjjApplyPageList/post.js";
import { getDictLabelSync as X } from "@oppein/op-utils";
import { defineComponent as Z, useTemplateRef as K, onMounted as ee, openBlock as h, createElementBlock as te, createElementVNode as N, createVNode as k, withCtx as C, createTextVNode as w, createBlock as H, createCommentVNode as I, Fragment as ae } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as se } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import le from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import oe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/pagination/src/Pagination.js";
import z from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import ie from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import { ref as y, unref as m } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const ne = { style: { width: "100%", display: "flex", "justify-content": "end" } }, re = { style: { width: "100%", display: "flex", "justify-content": "center" } }, Ce = /* @__PURE__ */ Z({
  __name: "indexTableItem",
  props: {
    businessId: { default: "" },
    businessType: { default: "business_serviceNo" },
    isShowAddApprovalButton: { type: Boolean, default: !1 },
    isAll: { type: Boolean, default: !1 },
    status: { default: "" },
    list: { default: () => [] }
  },
  emits: ["submit", "cancal", "addApproval"],
  setup(i, { expose: o, emit: l }) {
    const p = i, f = K("relatedApprovalContainer"), v = se(), c = y([]), g = y(!0), u = y(0), d = y([]), b = y(!1), L = [
      {
        type: "selection",
        multiple: !g.value,
        disabled(t) {
          return !["draft", "auditing", "pass"].includes(t.status);
        }
      },
      {
        title: "流程编号",
        key: "no",
        align: "center"
      },
      {
        title: "申请类型",
        key: "applyTypeName",
        align: "center"
      },
      {
        title: "流程处理状态",
        key: "statusName",
        align: "center"
      },
      {
        title: "发起对象类型",
        key: "businessTypeName",
        align: "center"
      },
      {
        title: "发起对象编码",
        key: "businessNo",
        align: "center"
      },
      {
        title: "审批品类",
        key: "vfdpApprovalCategoryName",
        align: "center"
      },
      {
        title: "审批类别",
        key: "vfdpApprovalCategoryType",
        align: "center"
      },
      {
        title: "客户姓名",
        key: "businessName",
        align: "center"
      },
      {
        title: "申请人",
        key: "applyer",
        align: "center"
      },
      {
        title: "申请时间",
        key: "applyDt",
        align: "center"
      }
    ], R = (t) => {
      g.value && t.length > 1 ? c.value = [t[t.length - 1]] : c.value = t;
    }, n = y({
      pageSize: 10,
      pageNum: 1,
      applyTypeList: ["bpm_process_djjspecial_judge"],
      businessType: "business_serviceNo",
      status: "",
      businessId: "",
      isCreatorId: void 0,
      statusList: void 0
    });
    ee(() => A(this, null, function* () {
      M();
    }));
    function P(t, a = "yyyy-MM-dd HH:mm:ss") {
      const e = typeof t == "string" || typeof t == "number" ? new Date(t) : t;
      if (isNaN(e.getTime()))
        return "";
      const r = (T) => T.toString().padStart(2, "0"), s = {
        yyyy: e.getFullYear().toString(),
        MM: r(e.getMonth() + 1),
        dd: r(e.getDate()),
        HH: r(e.getHours()),
        mm: r(e.getMinutes()),
        ss: r(e.getSeconds())
      };
      return a.replace(/yyyy|MM|dd|HH|mm|ss/g, (T) => s[T] || "");
    }
    const _ = () => A(this, null, function* () {
      var t, a;
      try {
        b.value = !0;
        let e = [], r = 0;
        if (n.value.businessType === "business_applyCode") {
          const s = yield W(n.value);
          e = (s == null ? void 0 : s.records) || [], r = (s == null ? void 0 : s.total) || 0;
        } else {
          const s = yield Q(n.value);
          e = ((t = s == null ? void 0 : s.data) == null ? void 0 : t.records) || [], r = ((a = s == null ? void 0 : s.data) == null ? void 0 : a.total) || 0;
        }
        d.value = e.map((s) => D(B({}, s), {
          applyDt: s.applyDt ? P(s.applyDt, "yyyy-MM-dd HH:mm:ss") : ""
        })), u.value = r, b.value = !1;
      } catch (e) {
        b.value = !1, console.error("请求失败:", e), d.value = [], u.value = 0;
      }
    }), V = (t) => {
      n.value.pageNum = t, _();
    }, E = (t) => {
      n.value.pageSize = t, _();
    }, O = () => {
      if (c.value.length === 0) {
        v.warning("至少选择一条数据");
        return;
      }
      const t = d.value.filter(
        (e) => c.value.includes(e.id)
      ), a = /* @__PURE__ */ new Set();
      if (t.forEach((e) => {
        e.vfdpApprovalCategory && e.vfdpApprovalCategory.split(/[,，]/).forEach((r) => {
          a.add(r.trim());
        });
      }), p.list && p.list.length > 0 && a.size > 0) {
        console.log("props.list--", p.list, a);
        for (const e of p.list)
          if (e.category && !a.has(e.category)) {
            const r = X(e.category, "ROOT_category") || e.category;
            v.warning(`空间产品名为${e.space || ""}的订单品类为${r}，不在关联的审核单品类范围内`);
            return;
          }
      }
      S("submit", t);
    }, S = l, U = () => {
      S("cancal");
    }, F = () => {
      S("addApproval");
    }, M = () => {
      if (n.value = {
        pageSize: 10,
        pageNum: 1,
        applyTypeList: ["bpm_process_djjspecial_judge"],
        businessType: p.businessType || "business_serviceNo",
        status: "",
        businessId: p.businessId,
        isCreatorId: void 0
      }, p.isAll ? n.value.status = "" : n.value.statusList = ["pass", "auditing", "draft"], !n.value.businessId)
        return !1;
      _();
    };
    return o({ init: M }), (t, a) => (h(), te(ae, null, [
      N("div", {
        ref_key: "relatedApprovalContainer",
        ref: f
      }, null, 512),
      k(m(ie), { show: b.value }, {
        default: C(() => [
          a[5] || (a[5] = N("div", { style: { "margin-bottom": "5px", color: "red" } }, "只有单据状态为审核通过后，订单才可传单", -1)),
          k(m(le), {
            columns: L,
            data: d.value,
            bordered: !1,
            "onUpdate:checkedRowKeys": R,
            "row-key": (e) => e.id
          }, null, 8, ["data", "row-key"]),
          N("div", ne, [
            k(m(oe), {
              page: n.value.pageNum,
              "onUpdate:page": a[0] || (a[0] = (e) => n.value.pageNum = e),
              "page-size": n.value.pageSize,
              "onUpdate:pageSize": a[1] || (a[1] = (e) => n.value.pageSize = e),
              "show-size-picker": "",
              "on-update:page": V,
              "on-update:page-size": E,
              "page-sizes": [10, 20, 30, 40]
            }, null, 8, ["page", "page-size"])
          ]),
          N("div", re, [
            k(m(z), { onClick: U }, {
              default: C(() => a[2] || (a[2] = [
                w("取消", -1)
              ])),
              _: 1,
              __: [2]
            }),
            d.value.length && (t.status == -1 || t.status == 0) ? (h(), H(m(z), {
              key: 0,
              onClick: O,
              style: { "margin-left": "30px" },
              type: "primary"
            }, {
              default: C(() => a[3] || (a[3] = [
                w("确定", -1)
              ])),
              _: 1,
              __: [3]
            })) : I("", !0),
            p.isShowAddApprovalButton ? (h(), H(m(z), {
              key: 1,
              onClick: F,
              style: { "margin-left": "30px" },
              type: "primary"
            }, {
              default: C(() => a[4] || (a[4] = [
                w("新增审批", -1)
              ])),
              _: 1,
              __: [4]
            })) : I("", !0)
          ])
        ]),
        _: 1,
        __: [5]
      }, 8, ["show"])
    ], 64));
  }
});
export {
  Ce as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/approval-table/indexTableItem.vue.js
// module id = 865
// module chunks = 67